import { CALL_API } from "redux-api-middleware";
import api from "apis/search";
import {
  REQUEST_SEARCH_RESULTS,
  RECEIVE_SEARCH_RESULTS,
  REQUEST_SEARCH_RESULTS_LOCAL,
  ERROR_SEARCH_RESULTS
} from "typeConstants";
import responseHandler from "responseHandler";

const getSearchResults = (text, localResultsOnly) => {
  if (localResultsOnly) {
    return dispatch =>
      dispatch({
        type: REQUEST_SEARCH_RESULTS_LOCAL,
        payload: text
      });
  } else {
    return (dispatch, getState) => {
      const gridFilters = getState().dashboard.gridFilters;
      dispatch({
        [CALL_API]: {
          endpoint: api.get(text),
          method: "POST",
          body: JSON.stringify(gridFilters),
          types: [
            {
              type: REQUEST_SEARCH_RESULTS,
              payload: text
            },
            {
              type: RECEIVE_SEARCH_RESULTS,
              payload: (action, state, res) =>
                res.json().then(data => {
                  return data;
                })
            },
            {
              type: ERROR_SEARCH_RESULTS,
              payload: (action, state, res) => {
                responseHandler.error(res, dispatch);
              }
            }
          ]
        }
      });
    };
  }
};

const getNewSearchResults = text => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getNew(text),
        method: "GET",
        types: [
          {
            type: REQUEST_SEARCH_RESULTS,
            payload: text
          },
          {
            type: RECEIVE_SEARCH_RESULTS,
            payload: (action, state, res) =>
              res.json().then(data => {
                return data;
              })
          },
          {
            type: ERROR_SEARCH_RESULTS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};
export { getSearchResults, getNewSearchResults };
